module.exports = __webpack_public_path__ + "static/media/close.e4a19d12.svg";